import { Outlet } from "react-router";
import { LeftNavBar } from "./LeftNavBar/LeftNavBar";
import { useEffect } from "react";
import {
  examplePatientStatus,
  usePostPatientStatus,
} from "@/store/tempRequest";

export const Layout = () => {
  const { mutate } = usePostPatientStatus();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "F7") {
        e.preventDefault();
        mutate(examplePatientStatus);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return !(opener && window.name.includes("Popup")) ? (
    <div className="flex w-full h-full min-h-[560px]">
      <div className="absolute top-0 left-0 h-full w-[260px]">
        <LeftNavBar />
      </div>
      <div className="flex h-[100vh] items-center ml-[260px] w-full overflow-auto">
        <div className="h-full mx-auto w-full min-w-[1000px] min-h-[600px]">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <Outlet />
  );
};
